<div class="card">
   <app-filter-container
      *ngIf="filters.length"
      [filters]="filters"
      [defaultFilterApplied]="defaultSelectedFilters"
      (appliedFilters)="loadPayments($event.origin, $event.filters)"
      class="mb-2"
   ></app-filter-container>

   <!-- LOADING TABLE SKELETON -->
   <div *ngIf="loading()">
      <p-table [value]="[{}, {}, {}, {}, {}, {}, {}, {}]">
         <ng-template pTemplate="header">
            <tr>
               <th>{{ 'DATA.MODULES.PAYMENTS.TABLE.ID' | translate }}</th>
               <th>{{ 'DATA.MODULES.PAYMENTS.TABLE.AMOUNT' | translate }}</th>
               <th>{{ 'DATA.MODULES.PAYMENTS.TABLE.DATE' | translate }}</th>
               <th>{{ 'DATA.MODULES.PAYMENTS.TABLE.COLLECTOR' | translate }}</th>
               <th>{{ 'DATA.MODULES.PAYMENTS.TABLE.METHOD' | translate }}</th>
               <th>{{ 'DATA.MODULES.PAYMENTS.TABLE.CUSTOMER' | translate }}</th>
               <th>{{ 'DATA.MODULES.PAYMENTS.TABLE.NUM_OPERATIONS' | translate }}</th>
               <th>{{ 'DATA.MODULES.PAYMENTS.TABLE.DETAILS' | translate }}</th>
            </tr>
         </ng-template>
         <ng-template pTemplate="body" let-row>
            <tr>
               <td><p-skeleton width="80px"></p-skeleton></td>
               <td><p-skeleton width="120px"></p-skeleton></td>
               <td><p-skeleton width="60px"></p-skeleton></td>
               <td><p-skeleton width="80px"></p-skeleton></td>
               <td><p-skeleton width="120px"></p-skeleton></td>
               <td><p-skeleton width="60px"></p-skeleton></td>
               <td><p-skeleton width="60px"></p-skeleton></td>
               <td><p-skeleton width="60px"></p-skeleton></td>
            </tr>
         </ng-template>
      </p-table>
   </div>

   <!-- DATA TABLE -->
   <p-table
      *ngIf="payments().length && !loading()"
      [value]="payments()"
      [loading]="loading()"
      [rows]="10"
      responsiveLayout="scroll"
   >
      <ng-template pTemplate="header">
         <tr>
            <th>{{ 'DATA.MODULES.PAYMENTS.TABLE.ID' | translate }}</th>
            <th>{{ 'DATA.MODULES.PAYMENTS.TABLE.AMOUNT' | translate }}</th>
            <th>{{ 'DATA.MODULES.PAYMENTS.TABLE.DATE' | translate }}</th>
            <th>{{ 'DATA.MODULES.PAYMENTS.TABLE.COLLECTOR' | translate }}</th>
            <th>{{ 'DATA.MODULES.PAYMENTS.TABLE.METHOD' | translate }}</th>
            <th>{{ 'DATA.MODULES.PAYMENTS.TABLE.CUSTOMER' | translate }}</th>
            <th>{{ 'DATA.MODULES.PAYMENTS.TABLE.NUM_OPERATIONS' | translate }}</th>
            <th>{{ 'DATA.MODULES.PAYMENTS.TABLE.DETAILS' | translate }}</th>
         </tr>
      </ng-template>

      <ng-template pTemplate="body" let-payment>
         <tr>
            <td>
               <div class="flex flex-row gap-2 align-items-center">
                  <p-button
                     [pTooltip]="'Copia external id del pago'"
                     icon="pi pi-copy"
                     [text]="true"
                     severity="secondary"
                     outlined="false"
                     (onClick)="payment.externalId && copyExternalId(payment.externalId)"
                     [disabled]="!payment.externalId"
                  ></p-button>

                  <span
                     [ngClass]="{
                        'font-italic text-bluegray-400': !payment.externalId
                     }"
                  >
                     {{ payment.externalId ? (payment.externalId | ellipsis: 30) : 'Fuera de Paymefy' }}
                  </span>
               </div>
            </td>
            <td>{{ payment.amount?.amount | currencyWithCode: payment.amount?.currency }}</td>
            <td>
               {{ payment.paymentDate | timezoneDate: true }}
            </td>
            <td><i class="pi pi-box pr-1"></i> {{ payment.collector.name }}</td>
            <td>
               <i class="pi pi-credit-card pr-1"></i>
               {{
                  payment.method === PaymentMethod.PAYMEFY
                     ? this.getFriendlyGatewayName(payment)
                     : this.getFriendlyMethodName(payment)
               }}
            </td>
            <td>
               <a
                  class="underline cursor-pointer text-primary align-items-center"
                  routerLink="{{ '/customers/customer/' + payment.customer.id }}"
                  [queryParamsHandling]="'preserve'"
               >
                  {{ payment.customer.name | ellipsis: 30 }}
               </a>
            </td>
            <td><p-chip [label]="payment.operations.length.toString()" /></td>
            <td>
               <p-button
                  [label]="'DATA.MODULES.PAYMENTS.ACTIONS.VIEW_DETAILS' | translate"
                  icon="pi pi-eye"
                  severity="secondary"
                  size="small"
                  (onClick)="openDetails(payment)"
               ></p-button>
            </td>
         </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
         <tr>
            <td class="p-d-flex p-align-center p-justify-center" colspan="9">
               {{ 'DATA.MODULES.OPERATIONS.PAGES.OPERATION_LIST.TABLE.MORE.NO_RESULTS' | translate }}
            </td>
         </tr>
      </ng-template>
   </p-table>

   <div
      *ngIf="!loading() && this.payments().length == 0"
      class="spinner-container text-center align-content-center mt-8 h-27rem"
   >
      <div class="text-900 font-bold text-6xl mb-4">
         {{ 'DATA.MODULES.PAYMENTS.EMPTY.TITLE' | translate }}
      </div>
      <div class="text-400 font-semibold text-xl mb-4">
         {{ 'DATA.MODULES.PAYMENTS.EMPTY.DESCRIPTION' | translate }}
      </div>
   </div>

   <div class="grid gap-2 w-full mt-4">
      <div class="col flex flex-column gap-1">
         <div class="col text-center flex justify-content-start w-full align-items-center gap-2">
            <span class="text-500 text-sm">
               {{ 'DATA.MODULES.PAYMENTS.PAGINATION.TOTAL_RESULTS' | translate }}
            </span>
            <span class="font-semibold text-sm text-700">
               {{ totalResults() }}
            </span>
         </div>

         <div
            class="col text-center flex justify-content-start w-full align-items-center gap-2 pt-0"
            *ngFor="let t of totalAmount()"
         >
            <span class="text-500 text-sm">
               {{ 'DATA.MODULES.PAYMENTS.PAGINATION.TOTAL_AMOUNTS' | translate }}
            </span>

            <span class="font-semibold text-sm text-700">
               {{ t.amount | currencyWithCode: t.currency }}
            </span>
         </div>
      </div>

      <div class="col text-center flex justify-center w-full align-items-center justify-content-center gap-3">
         <!-- Extract to comp. on second use -->
         <p-button
            severity="primary"
            icon="pi pi-angle-left"
            [disabled]="loading() || currentPage() === 1"
            styleClass="p-button-text"
            (click)="loadPayments(SearchOrigin.LOAD_PREV, facade.lastCriteria())"
         ></p-button>
         <p-button type="button" icon="pi pi-refresh" (onClick)="resetCalls()" styleClass="p-button-text" />
         <p-button
            severity="primary"
            type="button"
            icon="pi pi-angle-right"
            [disabled]="loading() || !hasMore()"
            styleClass="p-button-text"
            (click)="loadPayments(SearchOrigin.LOAD_NEXT, facade.lastCriteria())"
         ></p-button>
      </div>

      <div class="col text-center flex justify-content-end w-full align-items-center gap-2">
         <span class="text-500 text-sm">{{ 'DATA.MODULES.PAYMENTS.PAGINATION.RESULTS_PER_PAGE' | translate }}</span>
         <p-button
            *ngFor="let size of [10, 25, 50, 100]"
            label="{{ size }}"
            (onClick)="setPageSize(size)"
            [rounded]="true"
            severity="secondary"
            size="small"
            [outlined]="facade.numResultsDisplayed() !== size"
         ></p-button>
      </div>
   </div>

   <p-confirmPopup>
      <ng-template pTemplate="content" let-message>
         <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border p-3 mb-3">
            <i [class]="message.icon" class="text-6xl text-primary-500"></i>
            <p>{{ message.message }}</p>
         </div>
      </ng-template>
   </p-confirmPopup>
</div>

<p-toast></p-toast>

<app-modal [visible]="showDetails()" (closeModal)="showDetails.set(false)">
   <app-payment-details
      *ngIf="showDetails()"
      [payment]="selectedPayment"
      (closeModal)="showDetails.set(false)"
   ></app-payment-details>
</app-modal>
